module.exports = __webpack_public_path__ + "assets/twilioSmsGateway.4f020582.svg";